import React from 'react';
import cn from 'clsx';
import { Typography } from '../../../typography';
import { desktopCardText, mobileCardText, utpCardHeader } from './utp-card-header-styles';

type UtpCardHeaderProps = {
  className?: string;
  title: string;
  mobileTitle?: string;
};

export const UtpCardHeader: React.FC<UtpCardHeaderProps> = ({ className, mobileTitle, title }) => (
  <>
    <Typography
      adaptive={false}
      className={cn(utpCardHeader, className, { [desktopCardText]: mobileTitle })}
      variant="m"
      size="subtitle">
      {title}
    </Typography>
    {mobileTitle && (
      <Typography
        adaptive={false}
        className={cn(utpCardHeader, className, { [mobileCardText]: mobileTitle })}
        variant="m"
        size="subtitle">
        {mobileTitle}
      </Typography>
    )}
  </>
);
